import Link from "next/link";
import type { ComponentProps } from "react";

interface LogoProps {
  className?: string;
  strokeClassName?: string;
}

export function Logo({
  className,
  strokeClassName = "stroke-white",
}: LogoProps) {
  return (
    <svg
      aria-label="Logo"
      className={className}
      fill="none"
      height="189"
      role="graphics-symbol"
      viewBox="0 0 198 189"
      width="198"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M119.4 0C135.134 0.000120179 150.703 5.80892 162.489 17.5918C174.167 29.2665 181.079 45.7285 181.86 65.3975L181.861 65.3984L181.862 65.4307L181.895 66.3506V66.3701L181.896 66.375V66.3896L181.896 66.4053V66.4258L181.914 67.1436L181.915 67.1885L181.916 67.2373L181.931 68.2432C181.949 70.4647 181.879 72.6692 181.734 74.8545C192.162 89.4487 197.565 106.224 197.565 122.806V122.817L197.56 123.631L197.561 123.647C197.359 141.329 190.814 157.684 178.327 169.642C165.863 181.578 148.733 187.949 129.376 188.146H129.365L128.462 188.149L128.458 188.15H128.453C111.508 188.15 96.7142 183.105 84.502 174.726C64.5178 178.995 43.123 178.815 22.3486 172.648C12.9501 169.858 7.59459 159.978 10.3838 150.581L10.3887 150.565L10.3916 150.557L10.5117 150.169L10.5146 150.159L10.5186 150.149L10.5195 150.145C12.3682 144.45 16.8453 140.309 22.1943 138.663C8.99577 128.709 0.190897 113.792 0.00292969 96.1943V96.1836L0 95.6309V95.6201C0 73.2533 11.1034 56.1425 27.2246 45.3203C37.2969 38.5589 49.1567 34.3057 61.4746 32.1387C75.6921 11.2138 97.2961 0.000205814 119.4 0Z"
        fill="currentColor"
      />
      <path
        className={strokeClassName}
        d="M27.4 155.633C91.915 174.783 165.912 126.685 164.152 66.8825C163.197 34.425 142.125 17.75 119.4 17.75C92.0725 17.75 62.355 41.9725 62.355 93.3325C62.355 131.225 86.9175 170.4 128.452 170.4C160.23 170.4 179.815 150.055 179.815 122.805C179.815 87.9175 148.115 48.13 82.095 48.13C47.95 48.13 17.75 64.1075 17.75 95.62C17.75 127.133 60.685 150.197 108.11 121.387"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="11.5"
      />
    </svg>
  );
}

export function HomeLink(props: Omit<ComponentProps<typeof Link>, "href">) {
  return (
    <Link aria-label="Home" className="flex items-center" href="/" {...props}>
      <Logo className="size-8 text-fg" strokeClassName="stroke-gray-100" />
    </Link>
  );
}
